import {
  RoofClaimCustomerLike as CustomerLike,
  roofClaimFilled as filled,
} from '../../../common/helpers/roofClaimGate'

// The gate itself lives in common so the app's Documentation tab shares it
// (13376571808); re-exported so existing web imports keep working.
export {
  ROOF_CLAIM_EVIDENCE_FIELDS,
  roofClaimLocked,
  roofClaimShown,
  roofClaimVisible,
} from '../../../common/helpers/roofClaimGate'

export function roofClaimComplete(customer: CustomerLike): boolean {
  return (
    filled(customer['roof_claiming_client_sign']) &&
    filled(customer['roof_claiming_company_rep_sign'])
  )
}

// A roof packet added to a legacy signed customer needs its own durable session
// and email receipt; it must not change the old primary agreement's v2 layout.
export function roofClaimStamp(customer: CustomerLike): {
  roof_claiming_flow_version?: string
} {
  return roofClaimComplete(customer) ||
    customer['roof_claiming_flow_version'] === 'guided-v1'
    ? {}
    : { roof_claiming_flow_version: 'guided-v1' }
}
export function roofClaimLegacy(customer: CustomerLike): boolean {
  return (
    roofClaimComplete(customer) &&
    customer['roof_claiming_flow_version'] !== 'guided-v1'
  )
}
export function roofClaimLegacyStatus(
  customer: CustomerLike,
  primaryLegacySigned: boolean,
  hasOtherContract: boolean,
): boolean {
  return (primaryLegacySigned || !hasOtherContract) && roofClaimLegacy(customer)
}
export function signingDeliveryField(
  roof: boolean,
): 'roof_claiming_signed_email_delivery' | 'contract_signed_email_delivery' {
  return roof
    ? 'roof_claiming_signed_email_delivery'
    : 'contract_signed_email_delivery'
}

/**
 * Roof Claim / Authorization report menu options (13411491362): local view
 * state like cover/certificate, never written to the customer. Unchecked =
 * off the screen and off "Download PDF". Pending signatures still count, so
 * guided signing brings the page back to reach its field, and the PDF emailed
 * at Finish is always the complete signed packet (V92).
 */
export interface RoofSectionDisplay {
  hidden: boolean
  noPDF: boolean
}
export const ROOF_SECTION_SHOWN: RoofSectionDisplay = {
  hidden: false,
  noPDF: false,
}
export function roofSectionDisplay(
  included: boolean,
  signingStarted: boolean,
  finishing: boolean,
): RoofSectionDisplay {
  return {
    hidden: !included && !signingStarted && !finishing,
    noPDF: !included && !finishing,
  }
}

/**
 * Remote link (13411491362): a receipt from before this link opened belongs to
 * another document, so it must not read as "this one was already emailed".
 */
export function linkDelivery(
  raw: string,
  linkOpenedAt: number,
): { shown: string; resend: boolean } {
  if (!raw) return { resend: false, shown: '' }
  try {
    const { status, updatedAt } = JSON.parse(raw)
    if (Number(updatedAt) < linkOpenedAt)
      return { resend: status === 'sent', shown: '' }
  } catch {}
  return { resend: false, shown: raw }
}

/** Date-picker values are calendar days stored at UTC midnight, not signing instants. */
export function roofClaimCalendarDate(value: unknown): string {
  const number = Number(value)
  if (!Number.isFinite(number) || number <= 0) return ''
  const date = new Date(number)
  return Number.isFinite(date.getTime()) ? date.toISOString().slice(0, 10) : ''
}
